import { createApp } from "vue";
import VueTailwindDatepicker from "vue-tailwind-datepicker";
import defaultAdminRouter from "@lifeeduAdmin/router";
import defaultAdminApp from "@lifeeduAdmin/App.vue";
import defaultAdminStore from "@lifeeduAdmin/store";
import "@lifeeduAdmin/assets/css/reset.css";
import "@lifeeduAdmin/assets/css/tailwind.css";
import tracker from "@lifeeduAdmin/plugins/openReplay";

const router = defaultAdminRouter;
const App = defaultAdminApp;
const store = defaultAdminStore;

const app = createApp(App).use(router).use(store).use(VueTailwindDatepicker);

app.config.globalProperties.$openReplay = tracker;
tracker.start();

app.mount("#app");
